import { render } from "./TableHeader.vue?vue&type=template&id=9b8eb9e0"
import script from "./TableHeader.vue?vue&type=script&lang=js"
export * from "./TableHeader.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./TableHeader.vue?vue&type=style&index=0&id=9b8eb9e0&lang=scss&module=true"
cssModules["$style"] = style0
script.render = render

export default script